import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";

import { useLocales } from "@/hooks";

export default function SelectLanguage() {
  const { allLangs, currentLang, onChangeLang } = useLocales();

  return (
    <Select
      size="small"
      value={currentLang.value}
      onChange={(event) => onChangeLang(event.target.value)}
      input={<OutlinedInput />}
      inputProps={{ "aria-label": "Select language" }}
      sx={{ minWidth: 140, mb: { xs: "1rem", sm: 0 } }}
    >
      {allLangs.map((lang) => (
        <MenuItem key={lang.value} value={lang.value} lang={lang.value}>
          {lang.label}
        </MenuItem>
      ))}
    </Select>
  );
}
